import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import * as serviceWorker from './serviceWorker';
import App from './containers/App/App';
import {Router} from 'react-router-dom';
import BrowserRouter from './stores/App/BrowserRouter';
import {Auth0Provider} from "@auth0/auth0-react";
import {Helmet} from "react-helmet";

ReactDOM.render(
  <Auth0Provider
    domain={process.env.REACT_APP_ENV === 'production' ? 'auth-exchange.corltech.com' : 'auth-exchange-dev.corltech.com'}
    clientId={process.env.REACT_APP_ENV === 'production' ? 'ygQsY1iG1JNxI3WnKUE1cJAGXtvehTRr' : 'ZpTJqZrvfud2F31WkcYgFzCkuxfVmw2W'}
    redirectUri={process.env.REACT_APP_ENV === 'production' ? 'https://exchange.corltech.com' : process.env.REACT_APP_ENV === 'development' ? 'https://corl-exchange-development.azureedge.net' : 'http://localhost:3000'}
    audience={'https://exchange.corltech.com'}
    useRefreshTokens>
      <Helmet>
        <script id="ze-snippet" src={process.env.REACT_APP_ENV === 'production' ? 'https://static.zdassets.com/ekr/snippet.js?key=3a0c45cb-3b9a-42f8-a375-dc3bbaf88073' : 'https://static.zdassets.com/ekr/snippet.js?key=80173648-45b8-4a91-a5c2-46829185690f'}> </script>
      </Helmet>
      <Router history={BrowserRouter.history}>
          <App/>
      </Router>
    </Auth0Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
